module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pp-tracklist': 1,
      'pp-tracklist--reverse': _vm.reversed
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('div', {
      class: {
        'pp-tracklist__item': 1,
        'pp-tracklist__item--playing': _vm.currentTrack && item.id == _vm.currentTrack.id
      },
      on: {
        "dblclick": function($event) {
          return _vm.playTrack(item)
        }
      }
    }, [(!_vm.maxRows || index < _vm.maxRows) ? _c('div', {
      staticClass: "pp-tracklist__item__container"
    }, [_c('div', {
      staticClass: "pp-tracklist__item__playnow",
      on: {
        "click": function($event) {
          return _vm.playTrack(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-play"
    })]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "pp-tracklist__item__number"
    }, [_vm._v("\n                " + _vm._s(item.position) + ".\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "pp-tracklist__item__title"
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "pp-tracklist__item__playnext",
      on: {
        "click": function($event) {
          return _vm.addToQueue(item)
        }
      }
    }, [_vm._v("\n                Add to queue\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "pp-tracklist__item__duration"
    }, [_vm._v("\n                " + _vm._s(_vm._f("duration")(item.duration)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "pp-tracklist__item__quality"
    }, [(item.formats.indexOf('flac') > -1) ? _c('span', [_vm._v("FLAC")]) : _vm._e()]), _vm._v(" "), (_vm.allowRemove) ? _c('div', {
      staticClass: "pp-tracklist__item__remove",
      on: {
        "click": function($event) {
          return _vm.removeTrack(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-close"
    })]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.paginating) ? _c('loading-indicator') : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-tracklist__item__playing"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4f7237","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackList.vue
// module id = 130
// module chunks = 0 1